/**
 * Maps CSV `img` filenames (e.g. assembly.svg) to bundled URLs under src/assets/cards_logo.
 * Supports .webp, .png, and .svg. Same basename: .webp wins, then .png, then .svg.
 */
const ctxSvg = require.context("../assets/cards_logo", false, /\.svg$/);
const ctxWebp = require.context("../assets/cards_logo", false, /\.webp$/);
const ctxPng = require.context("../assets/cards_logo", false, /\.png$/i);

/** @type {Record<string, { svg?: string, webp?: string, png?: string }>} */
const byBase = {};

function basenameKey(name) {
  return String(name || "")
    .replace(/^\.\//, "")
    .replace(/\.(svg|webp|png)$/i, "")
    .toLowerCase();
}

function register(key, url, kind) {
  const base = basenameKey(key);
  if (!base) return;
  if (!byBase[base]) byBase[base] = {};
  byBase[base][kind] = url;
}

ctxSvg.keys().forEach((key) => register(key, ctxSvg(key), "svg"));
ctxWebp.keys().forEach((key) => register(key, ctxWebp(key), "webp"));
ctxPng.keys().forEach((key) => register(key, ctxPng(key), "png"));

/**
 * @returns {{ url: string, format: 'svg' | 'webp' | 'png' } | null}
 */
function resolveCardsLogo(filename) {
  if (!filename || typeof filename !== "string") return null;
  const base = basenameKey(filename.trim());
  if (!base) return null;
  const slot = byBase[base];
  if (!slot) return null;
  if (slot.webp) return { url: slot.webp, format: "webp" };
  if (slot.png) return { url: slot.png, format: "png" };
  if (slot.svg) return { url: slot.svg, format: "svg" };
  return null;
}

export function getCardsLogoUrl(filename) {
  const r = resolveCardsLogo(filename);
  return r?.url ?? null;
}

/** Raster formats must not be fetched as SVG text in DataService. */
export function getCardsLogoMediaKind(filename) {
  const r = resolveCardsLogo(filename);
  return r?.format ?? null;
}

/** True for bundled logos that are raster images (WebP or PNG), not SVG. */
export function isCardsLogoRaster(filename) {
  const k = getCardsLogoMediaKind(filename);
  return k === "webp" || k === "png";
}
